// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wysiwyg_wrapper__F4zBB"};